import { render, staticRenderFns } from "./Marzipano.vue?vue&type=template&id=52d251fa&"
import script from "./Marzipano.vue?vue&type=script&lang=js&"
export * from "./Marzipano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports